import React from 'react'
import BrandName from './BrandName'
import { ProfilerQuestionID } from '../../config/QuestionEnum'
import { getQuestionConfig } from '../../config/questionsConfig';
import { PROFILER_IMAGES } from '../../Common/constants';
const questionConfig = getQuestionConfig(ProfilerQuestionID.BCM_TILES_AND_ADHESIVE_BRANDS);

const BCMBrandTilesAndAdhesive = (props) => {
  return (
    <BrandName
      questionId={ProfilerQuestionID.BCM_TILES_AND_ADHESIVE_BRANDS}
      title={questionConfig?.question}
      subtitle={questionConfig?.subtitle}
      options={questionConfig?.options || []}
      suggestions={['Kajaria', 'Somany', 'Johnson Tiles', 'Nitco', 'Roff']}
      icon={PROFILER_IMAGES.tile_adhesive}
      {...props}
    />
  )
}

export default BCMBrandTilesAndAdhesive
